import { OrderStatus } from '../../../../../../graphql/order/models';

export const isOrderClosed = (status?: OrderStatus) => {
  return status === OrderStatus.canceled
    || status === OrderStatus.canceledByPatient
    || status === OrderStatus.canceledAutomatically
    || status === OrderStatus.fulfilled;
};

export const getIsCancelledOrder = (status?: OrderStatus) => {
  return status === OrderStatus.canceled
    || status === OrderStatus.canceledByPatient
    || status === OrderStatus.canceledAutomatically;
};

export const getIsFulfilledOrder = (status?: OrderStatus) => {
  return status === OrderStatus.fulfilled;
};

export const getIsConfirmedOrder = (status?: OrderStatus) => {
  return status === OrderStatus.confirmed;
};
